function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_521:5044)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3,
  width: 40,
  height: 40,
  rx: 6,
  fill: "#FFB72C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.5018 16.8265C31.5018 12.1264 27.692 8.31006 23 8.31006C18.3079 8.31006 14.4982 12.1264 14.4982 16.8265C14.4982 20.683 17.1851 24.1378 20.8745 25.1019L21.5964 27.0301C19.5912 27.1506 16.2226 27.6327 16.2226 29.3199C16.2226 31.6097 22.3182 31.6901 23.0401 31.6901C23.7619 31.6901 29.8576 31.6097 29.8576 29.3199C29.8576 27.5925 26.4488 27.1506 24.4437 27.0301L25.1254 25.1421C28.8149 24.1779 31.5018 20.7232 31.5018 16.8265ZM25.7671 16.8265C25.7671 18.353 24.5239 19.5983 23 19.5983C21.4761 19.5983 20.2329 18.353 20.2329 16.8265C20.2329 15.3 21.4761 14.0546 23 14.0546C24.5239 14.0546 25.7671 15.3 25.7671 16.8265ZM28.4139 29.3199C28.0129 29.7216 26.0478 30.3242 23 30.3242C19.9923 30.3242 18.0272 29.7216 17.5861 29.3199C17.947 28.9584 19.5912 28.4361 22.0776 28.3558L22.5188 29.5208C22.599 29.7216 22.7594 29.8422 23 29.8422C23.2005 29.8422 23.401 29.7216 23.4812 29.5208L23.8823 28.3558C26.4087 28.4361 28.0129 28.9584 28.4139 29.3199Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_521:5044",
  x: 0,
  y: 0,
  width: 46,
  height: 47,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0509804 0 0 0 0 0.0431373 0 0 0 0 0.0470588 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_521:5044"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_521:5044",
  result: "shape"
})));

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.88f82953.svg";
export { ForwardRef as ReactComponent };